module.exports = __webpack_public_path__ + "static/media/Avi_Szenberg_Picture.acfe42d1.jpg";